// Field schemas for each CMS collection, consumed by CollectionManager.
// type: text | number | textarea | image | select | datetime | list
// idField: if set, the doc id is taken from that field (e.g. slug) so public
//          detail routes (/listings/:slug) stay stable.

const STATUS = { name: "status", label: "Visibility", type: "select", options: ["published", "draft"], default: "draft" };
const ORDER = { name: "order", label: "Sort order", type: "number", default: 99 };

export const COLLECTIONS = {
  listings: {
    label: "Listings",
    coll: "listings",
    idField: "slug",
    titleField: "title",
    fields: [
      { name: "slug", label: "Slug (URL)", type: "text", required: true },
      { name: "title", label: "Title", type: "text", required: true },
      { name: "type", label: "Property type", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "district", label: "District", type: "text" },
      { name: "price", label: "Price (display)", type: "text" },
      { name: "priceValue", label: "Price (number)", type: "number" },
      { name: "bedrooms", label: "Bedrooms", type: "number" },
      { name: "bathrooms", label: "Bathrooms", type: "number" },
      { name: "area", label: "Area (display)", type: "text" },
      { name: "areaValue", label: "Area (sqft number)", type: "number" },
      { name: "tenure", label: "Tenure", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "image", label: "Cover image", type: "image" },
      { name: "gallery", label: "Gallery images", type: "imageList" },
      { name: "listingStatus", label: "Listing status", type: "select", options: ["Available", "Coming Soon", "Sold", "Rented"], default: "Available" },
      { name: "waMessage", label: "WhatsApp prefill message", type: "textarea" },
      ORDER,
      STATUS,
    ],
  },
  provenResults: {
    label: "Proven Results",
    coll: "provenResults",
    titleField: "headline",
    fields: [
      { name: "headline", label: "Headline", type: "text", required: true },
      { name: "sub", label: "Subtitle", type: "text" },
      { name: "metric", label: "Metric", type: "text" },
      { name: "story", label: "Story", type: "textarea" },
      { name: "image", label: "Image", type: "image" },
      ORDER,
      STATUS,
    ],
  },
  testimonials: {
    label: "Testimonials",
    coll: "testimonials",
    titleField: "name",
    fields: [
      { name: "name", label: "Client name", type: "text", required: true },
      { name: "role", label: "Role", type: "text" },
      { name: "quote", label: "Quote", type: "textarea", required: true },
      ORDER,
      STATUS,
    ],
  },
  awards: {
    label: "Awards",
    coll: "awards",
    titleField: "title",
    fields: [
      { name: "title", label: "Award title", type: "text", required: true },
      { name: "year", label: "Year", type: "text" },
      { name: "org", label: "Organisation", type: "text" },
      { name: "body", label: "Description", type: "textarea" },
      ORDER,
      STATUS,
    ],
  },
  blogs: {
    label: "Blogs",
    coll: "blogs",
    idField: "slug",
    titleField: "title",
    fields: [
      { name: "slug", label: "Slug (URL)", type: "text", required: true },
      { name: "title", label: "Title", type: "text", required: true },
      { name: "excerpt", label: "Excerpt", type: "textarea" },
      { name: "body", label: "Body (HTML)", type: "textarea" },
      { name: "category", label: "Category", type: "text" },
      { name: "date", label: "Date (display)", type: "text" },
      { name: "publishAt", label: "Publish date/time", type: "datetime" },
      { name: "readTime", label: "Read time", type: "text" },
      { name: "image", label: "Cover image", type: "image" },
      { name: "status", label: "Visibility", type: "select", options: ["published", "draft", "scheduled"], default: "draft" },
    ],
  },
};

export const COLLECTION_KEYS = Object.keys(COLLECTIONS);
